import { track } from './analytics';
import { claimSessionEvent, claimPersistentEvent } from './analyticsOnce';

export function trackGoogleSignupCompleted(input: {
  userId: string; provider: string | undefined; wasIncomplete: boolean; organizationId: unknown;
}): void {
  if (input.provider !== 'google' || !input.wasIncomplete || typeof input.organizationId !== 'string' || !input.organizationId) return;
  const identity = `google-signup:${input.userId}:${input.organizationId}`;
  if (!claimPersistentEvent(identity)) return;
  track('signup_completed', { provider: 'google', needs_confirmation: false, event_id: identity });
}

export function trackProposalAccepted(proposalId: string | undefined, source: 'proposal' | 'estimate'): void {
  if (!proposalId) return;
  const identity = `proposal-accepted:${proposalId}`;
  if (!claimSessionEvent(identity)) return;
  track('proposal_accepted', { source, event_id: identity });
}
